module.exports = __webpack_public_path__ + "f3050b5f43d0139b7bb3da579d65a492.png";